import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Portal from "./pages/Portal";
import Home from "./pages/Home";
import DocsLayout from "./layouts/DocsLayout";
import GettingStarted from "./pages/GettingStarted";
import ProfileCard from "./pages/ProfileCard";
import MemberEventCards from "./pages/MemberEventCards";
import LevelUpCard from "./pages/LevelUpCard";
import AchievementCard from "./pages/AchievementCard";
import ShipCard from "./pages/ShipCard";
import LeaderboardCard from "./pages/LeaderboardCard";
import NowPlayingCard from "./pages/NowPlayingCard";
import GiveawayCard from "./pages/GiveawayCard";
import BirthdayCard from "./pages/BirthdayCard";
import MarriageCard from "./pages/MarriageCard";
import WeeklyRecapCard from "./pages/WeeklyRecapCard";
import CodeSnippetCard from "./pages/CodeSnippetCard";
import ColorSystem from "./pages/ColorSystem";
import Playground from "./pages/Playground";
import NotFound from "./pages/NotFound";

export default function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <Routes>
      <Route path="/" element={<Portal />} />
      <Route path="/docs/kira-arts" element={<Home />} />
      <Route path="/docs/kira-arts" element={<DocsLayout />}>
        <Route path="getting-started" element={<GettingStarted />} />
        <Route path="cards/profile" element={<ProfileCard />} />
        <Route path="cards/welcome-leave" element={<MemberEventCards />} />
        <Route path="cards/levelup" element={<LevelUpCard />} />
        <Route path="cards/achievement" element={<AchievementCard />} />
        <Route path="cards/ship" element={<ShipCard />} />
        <Route path="cards/leaderboard" element={<LeaderboardCard />} />
        <Route path="cards/now-playing" element={<NowPlayingCard />} />
        <Route path="cards/giveaway" element={<GiveawayCard />} />
        <Route path="cards/birthday" element={<BirthdayCard />} />
        <Route path="cards/marriage" element={<MarriageCard />} />
        <Route path="cards/weekly-recap" element={<WeeklyRecapCard />} />
        <Route path="cards/code-snippet" element={<CodeSnippetCard />} />
        <Route path="color-system" element={<ColorSystem />} />
        <Route path="playground" element={<Playground />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
